const round = num => Math.round((parseFloat(num) + 0.00001) * 100) / 100
const optionsUsd = { style: 'currency', currency: 'USD', numberingSystem: "latn" };
const numberFormatUsd = new Intl.NumberFormat('en-US', optionsUsd);
const optionsCR = { style: 'currency', currency: 'CRC', useGrouping: 'false', useGrouping: 'always' };
const numberFormatCR = new Intl.NumberFormat('es-CR', optionsCR);

const buildDetTable = (coverages, rates, planId = 0) => {

    let cob = [];
    coverages.map(item => {
        let cobertura = rates.find(x => x.idCob == item.idCob && x.bIncluirCob == false);
        if (cobertura != undefined) {
            let priMount = parseFloat(parseFloat(cobertura.prima) * parseFloat((parseFloat(cobertura.pRecargo) / 100) + 1)).toFixed(2);
            cob.push({
                "nombre": item.nombre,
                "prima": planId == 551 ? numberFormatCR.format(priMount) : numberFormatUsd.format(priMount),
                "sa": cobertura.sa,
                "valor": planId == 551 ? numberFormatCR.format(Number.parseFloat(cobertura.sa).toFixed(2)) : numberFormatUsd.format(Number.parseFloat(cobertura.sa).toFixed(2))
            });
        }
    })
    return cob;
};


const getTotalFormat = (rates = [], planId = 0) => {
    if (rates.length === 0) return 0;
    const total = rates.map(x => ({ ...x, prima: round(x.prima) + round((x.prima * x.pRecargo) / 100) })).sum('prima');
    return planId == 551 ? numberFormatCR.format(Number.parseFloat(total).toFixed(2)) : numberFormatUsd.format(Number.parseFloat(total).toFixed(2));
}

const getTotal = (rates = [], planId = 0) => {
    if (rates.length === 0) return 0;
    const total = rates.map(x => ({ ...x, prima: round(x.prima) + round((x.prima * x.pRecargo) / 100) })).sum('prima');
    return planId == 551 ? Number.parseFloat(total).toFixed(2) : Number.parseFloat(total).toFixed(2);
}


const getSummary = (data) => {

    let result = {};
    let planConfig = data.catalogs.planConfig;
    let porDesc = planConfig.descuentoMaximo != undefined ? planConfig.descuentoMaximo : 0;
    let bonus = data.catalogs.rates.rates.map(x => ({ ...x, prima: round(x.prima) + round((x.prima * x.pRecargo) / 100) })).sum('prima');

    //let desc = parseFloat(parseFloat(bonus) * (parseFloat(porDesc) / 100)).toFixed(2);
    let desc = GetDescPolicy(data, porDesc);

    let bonus2 = parseFloat(parseFloat(bonus).toFixed(2) - parseFloat(desc)).toFixed(2);

    let financing = 0;
    let tax2Lst = planConfig.intereses != undefined ? planConfig.intereses : undefined;
    if (tax2Lst !== undefined) {
        let tax2P = tax2Lst.find(x => x.frecuenciaPago === parseInt(data.paymentFrequency));
        if (tax2P !== undefined)
            financing = parseFloat(parseFloat(bonus2) * parseFloat(parseFloat(tax2P.porcentajeInteres) / 100)).toFixed(2);

    }

    let tax = parseFloat(parseFloat(bonus2) * (parseFloat(planConfig.impuestos.interes) / 100)).toFixed(2);
    let total = parseFloat(parseFloat(bonus2) + parseFloat(tax) + parseFloat(financing)).toFixed(2);
    let dEmission = 0;





    result["total"] = total;
    result["bonus"] = bonus;
    result["desc"] = desc;
    result["bonus2"] = bonus2;
    result["pDesc"] = porDesc;
    result["financing"] = financing;
    result["tax"] = tax;
    result["totalFormat"] = data.planId == 551 ? numberFormatCR.format(Number.parseFloat(total).toFixed(2)) : numberFormatUsd.format(Number.parseFloat(total).toFixed(2));
    result["bonusFormat"] = data.planId == 551 ? numberFormatCR.format(Number.parseFloat(bonus).toFixed(2)) : numberFormatUsd.format(Number.parseFloat(bonus).toFixed(2));
    result["descFormat"] = data.planId == 551 ? numberFormatCR.format(Number.parseFloat(desc).toFixed(2)) : numberFormatUsd.format(Number.parseFloat(desc).toFixed(2));
    result["bonus2Format"] = data.planId == 551 ? numberFormatCR.format(Number.parseFloat(bonus2).toFixed(2)) : numberFormatUsd.format(Number.parseFloat(bonus2).toFixed(2));
    result["taxFormat"] = data.planId == 551 ? numberFormatCR.format(Number.parseFloat(tax).toFixed(2)) : numberFormatUsd.format(Number.parseFloat(tax).toFixed(2));
    result["dEmissionFormat"] = data.planId == 551 ? numberFormatCR.format(Number.parseFloat(dEmission).toFixed(2)) : numberFormatUsd.format(Number.parseFloat(dEmission).toFixed(2));
    result["financingFormat"] = data.planId == 551 ? numberFormatCR.format(Number.parseFloat(financing).toFixed(2)) : numberFormatUsd.format(Number.parseFloat(financing).toFixed(2));

    return result
}


const buildData = (data, src) => {

    let lstBeneficiary = [];
    let lstAnswers = [];
    let polCobs = [];
    let polCobsDesc = [];



    let policy = {
        "Plan": data.planId,
        "SA": data.vehicleValue,
        "Prima": data.bonus,
        "Descuento": data.desc,
        "PrimaDE": data.bonus,
        "PrimaNeta": data.bonus2,
        "PrimaExonerada": 0,
        "Impuesto": data.tax,
        "Total": data.total,
        "Frecuencia": data.paymentFrequency,
        "Cuotas": GetFee(data.paymentFrequency),
        "Estado": 0,
        "mInteres": data.financing,
        "Source": src
    }

    let au = {
        "SA": data.vehicleValue,
        "auMarca": data.brandName.trim(),
        "auModelo": data.modelName.trim(),
        "auAnio": data.year,
        "auCategoria": data.pricing.auCategoria,
        "auValorNuevo": data.vehicleValue,
        "auNumPasajeros": data.pricing.auNumPasajeros,
        "auUso": data.pricing.usoo,
        "codigoMarca": data.pricing.marca,
        "codigoModelo": data.pricing.modelo,
        "auGPS": data.pricing.GPS,
        "auNuevo": data.vehicleStatus === "1", true: false,
        "ideducible": data.pricing.dedu,
        "irastreoSatelital": data.pricing.rsat,
    };

    let insured = {
        "TipoId": data.typeId,
        "NumId": data.identificationNumber,
        "Nombre": data.firstName,
        "Apellido": data.lastName,
        "TelefonoCelular": data.cellphoneNumber,
        "Email": data.mail,
        "EstadoCivil": '0'
    }
    const coberDesc = [63, 62, 78, 66, 61];
    data.catalogs.rates.rates.map((element) => {
        let titleRate = data.catalogs.coverages.coverages.find(x => x.idCob == element.idCob);

        if (titleRate !== null) {
            element["Nombre"] = titleRate.nombre;
            element["orden"] = titleRate.orden;
        }
        let pRecargo = parseFloat((parseFloat(element["pRecargo"]).toFixed(2) / 100) + 1).toFixed(2);
        element["Prima"] = parseFloat(parseFloat(element.prima) * pRecargo).toFixed(2);
        if (coberDesc.includes(element.idCob))
            element["pdescuento"] = element["Prima"] !== '0' ? data.pDesc : 0;
        else
            element["pdescuento"] = 0;
        let pdescuentoMonto = parseFloat(parseFloat(element["pdescuento"]).toFixed(2) / 100).toFixed(2);

        element["mprimabruta"] = parseFloat(parseFloat(element["Prima"]).toFixed(2) - (parseFloat(element["Prima"]).toFixed(2) * pdescuentoMonto)).toFixed(2);
        element["PrimaGravada"] = element["mprimabruta"];
        element["mdescuento"] = element["Prima"] !== '0' ? parseFloat(parseFloat(element["Prima"]) * pdescuentoMonto).toFixed(2) : 0;
        element["bDescuentoManual"] = 0;
        element["Etiqueta"] = 0;
        element["PrimaDE"] = element["PrimaGravada"];
        polCobs.push(element);

        //AGREGAMOS POLIZAS DESCUENTO

        if (parseFloat(element["mdescuento"]) > 0) {
            let polCobsDescTemp = {};

            if (element.descuentos != undefined) {
                if (element.descuentos.length > 0) {
                    polCobsDescTemp["idCob"] = element.idCob;
                    polCobsDescTemp["codDesc"] = element.descuentos[0].codigoDescuento;
                    polCobsDescTemp["pdescuento"] = element["pdescuento"];
                    polCobsDescTemp["mdescuento"] = element["mdescuento"];
                    polCobsDescTemp["fechaingreso"] = Date.now;
                    polCobsDesc.push(polCobsDescTemp);
                }
            }


        }
    });

    policy["Respuesta"] = lstAnswers;
    policy["Beneficiarios"] = lstBeneficiary;
    policy["PolCobs"] = polCobs; //polCobsDesc
    policy["PolCobsDesc"] = polCobsDesc;
    policy["Au"] = au;
    policy["Asegurado"] = insured;
    policy["FormaPagos"] = "";

    return policy;

}

const buildDataError = (data) => {
    let insured = {
        "TipoId": data.typeId,
        "NumId": data.identificationNumber,
        "Nombre": data.firstName,
        "Apellido": data.lastName,
        "TelefonoCelular": data.cellphoneNumber,
        "Email": data.mail,
        "EstadoCivil": '0'
    }
    return insured;
}


const GetDescPolicy = (data, porDesc) => {

    let mountDescount = 0;
    const coberDesc = [63, 62, 78, 66, 61];
    data.catalogs.rates.rates.map((element) => {
        let pDesc = 0;
        let cobDesc = 0;
        if (coberDesc.includes(element.idCob))
            pDesc = element["Prima"] !== '0' ? porDesc : 0;
        else
            pDesc = 0;
        var pdescuentoMonto = parseFloat(parseFloat(pDesc) / 100).toFixed(2);
        var pRecargo = parseFloat((parseFloat(element.pRecargo).toFixed(2) / 100) + 1).toFixed(2);
        cobDesc = element["Prima"] !== '0' ? parseFloat(parseFloat(element.prima * pRecargo) * pdescuentoMonto).toFixed(2) : 0;
        mountDescount = parseFloat(parseFloat(mountDescount) + parseFloat(cobDesc)).toFixed(2);
    });

    return mountDescount;
}

const GetFee = (type) => {
    switch (type) {
        case "1": return 1; // anual
        case "12": return 12; // mensual
        case "2": return 2; // semestral
        case "4": return 4; // trimestral
        default: return 1;
    }
}


export { buildDetTable, getTotalFormat, getTotal, buildData, buildDataError, getSummary, GetDescPolicy };

